import { BOOKED_SLOT, FREE_SLOT, FULL_SLOT } from 'shared/consts/styleValues';
import { formatTime } from 'shared/lib/time';
import { Timeslot, TimeslotMapItem } from '../../../model/types';
import { TColorSlot } from 'shared/types/stylesTypes';

const getFormatTime = (
	slot: Timeslot,
	getTime: boolean = false,
): string | false => {
	const formatedTime = formatTime({ time: slot.dt_start });
	if (
		!formatedTime ||
		isNaN(new Date(slot.dt_start).getTime()) ||
		isNaN(new Date(slot.dt_end).getTime())
	) {
		return false;
	}

	if (getTime) {
		return formatedTime.time;
	}

	return formatedTime.hours;
};

export const mappingTimeslots = (timeslots: Timeslot[]) => {
	const map = new Map();
	if (timeslots && timeslots.length) {
		timeslots.map(slot => {
			const slots: TimeslotMapItem[] = [];
			const hours = getFormatTime(slot);
			if (!hours) {
				return false;
			}

			timeslots.map((slot, index) => {
				if (slot.dt_start.indexOf(`T${hours}:`) != -1) {
					const time = getFormatTime(slot, true);
					if (!time) {
						return false;
					}

					let color: TColorSlot = FREE_SLOT;

					if (slot.booked || slot.is_overbooked) {
						color = BOOKED_SLOT;
					}

					if (!slot.vacancies) {
						color = FULL_SLOT;
					}

					const minuteBeginSlot = new Date(
						slot.dt_start,
					).getUTCMinutes();
					const cloneSlot: TimeslotMapItem = {
						...slot,
						time,
						selected: false,
						minuteBeginSlot,
						minuteEndSlot: 59,
						color,
					};

					const nextSlot = timeslots[index + 1];
					if (nextSlot) {
						const minuteEndSlot = new Date(
							nextSlot.dt_start,
						).getUTCMinutes();
						if (minuteEndSlot > 0) {
							cloneSlot.minuteEndSlot = minuteEndSlot;
						}
					}

					slots.push(cloneSlot);
				}
			});

			map.set(hours, slots);
		});
	}

	return [...map.entries()];
};
